/* Yaniko — сборната страница.

   Рисува лентата с топчетата и картинките на петте пътя от СЪЩИТЕ данни, които
   вървят в конфигуратора. Така страницата показва камъните, които наистина се
   изработват, и не остарява, когато каталогът се смени. */
(function () {
  'use strict';

  var D = window.YGK_DATA || {};
  if (!D.gems || !D.gems.length) return;

  var PX = 5.6;                    // пиксели на милиметър за украсните ленти

  function pick(type, size) {
    var hit = D.gems.filter(function (g) {
      return g.type === type && (!size || g.size === size);
    });
    return hit.length ? hit[0] : null;
  }

  function bead(o) {
    var b = document.createElement('span');
    b.className = 'ygkh-bead ' + (o.gold ? 'ygkh-bead--gold' : 'ygkh-bead--gem');
    b.style.width = b.style.height = Math.round(o.size * PX) + 'px';
    if (!o.gold && o.gem) {
      b.style.background = o.gem.hex;
      if (o.gem.image) {
        var img = new Image();
        img.onload = function () {
          b.style.backgroundImage = 'url("' + o.gem.image + '")';
          b.style.backgroundSize = 'cover';
        };
        img.src = o.gem.image;
      }
    }
    return b;
  }

  /* Подредбата на konec: злато в средата, камъни към краищата. */
  function fill(host, gem, goldSize, goldCount, total) {
    var out = [];
    var stones = Math.max(0, total - goldCount);
    var before = Math.floor(stones / 2);

    for (var i = 0; i < before; i++) out.push({ gem: gem, size: gem.size });
    for (var g = 0; g < goldCount; g++) {
      out.push({ gold: true, size: goldSize });
      if (g < goldCount - 1 && out.length < total) out.push({ gem: gem, size: gem.size });
    }
    while (out.length < total) out.push({ gem: gem, size: gem.size });

    out.forEach(function (o) { host.appendChild(bead(o)); });
  }

  /* Всяка карта носи различна лента — това е разликата между петте пътя,
     показана вместо описана. */
  var ARTS = {
    simple:  function (h) { fill(h, pick('Оникс', 3) || D.gems[0], 2, 5, 15); },
    pro:     function (h) {
      var o = pick('Оникс', 3) || D.gems[0];
      [2, 4, 2, 5, 2, 6, 2, 4, 2].forEach(function (s, i) {
        h.appendChild(bead(i % 2 ? { gold: true, size: s } : { gem: o, size: o.size }));
      });
    },
    presets: function (h) { fill(h, pick('Хематит', 3) || D.gems[0], 2, 5, 15); },
    stones:  function (h) {
      ['Оникс', 'Перла', 'Хематит', 'Кехлибар', 'Ахат'].forEach(function (t) {
        var g = pick(t);
        if (g) h.appendChild(bead({ gem: g, size: 6 }));
      });
    },
    astral:  function (h) {
      ['Кехлибар', 'Хематит', 'Яспис'].forEach(function (t, i) {
        var g = pick(t);
        if (g) h.appendChild(bead({ gem: g, size: 7 }));
        if (i < 2) h.appendChild(bead({ gold: true, size: 3 }));
      });
    }
  };

  function boot() {
    var root = document.querySelector('[data-ygk-hub]');
    if (!root) return;

    var strip = root.querySelector('.ygkh-strip');
    if (strip) fill(strip, pick('Оникс', 3) || D.gems[0], 2, 11, 46);

    root.querySelectorAll('.ygkh-path__art').forEach(function (h) {
      var f = ARTS[h.getAttribute('data-art')];
      if (f) f(h);
    });

    // Кой път се хваща най-често — това решава кой да е първи следващия път.
    root.querySelectorAll('[data-ygkh]').forEach(function (a) {
      a.addEventListener('click', function () {
        if (window.YGKShared) window.YGKShared.track('hub_click', { target: a.getAttribute('data-ygkh') });
      });
    });

    if (window.YGKShared) window.YGKShared.trackOnce('view_hub', {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
